import { cn } from "@/lib/class-control";
import { Check } from "lucide-react";

interface CheckboxProps {
  id?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label?: string;
  className?: string;
}

export function Checkbox({ id, checked, onCheckedChange, label, className }: CheckboxProps) {
  return (
    <div className="flex items-center gap-1.5">
      <button
        type="button"
        role="checkbox"
        aria-checked={checked}
        id={id}
        onClick={() => onCheckedChange(!checked)}
        className={cn(
          "size-4 rounded border flex items-center justify-center transition-colors",
          checked
            ? "bg-primary border-primary"
            : "bg-transparent border-gray-600 hover:border-gray-500",
          className
        )}
      >
        {checked && <Check className="size-2.5 text-white" />}
      </button>
      {label && (
        <label
          htmlFor={id}
          onClick={() => onCheckedChange(!checked)}
          className="text-xs text-white cursor-pointer select-none"
        >
          {label}
        </label>
      )}
    </div>
  );
}
